// extracted by mini-css-extract-plugin
export default {"modalButtons":"ChangeUserRoleModal_modalButtons__n4yzS","cancelButton":"ChangeUserRoleModal_cancelButton__Sf9oa"};